import React from 'react';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  useDisclosure,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { LogoHeader } from './LogoHeader';
import { AccountOptions } from './AccountOptions';
import { OrganizationsSelect } from './OrganizationsSelect';
import { StatsMenu } from './StatsMenu';

export const NavDrawer = ({ ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box {...props}>
      <Flex
        position="relative"
        padding={4}
        justifyContent="center"
        alignItems="center"
      >
        <IconButton
          position="absolute"
          backgroundColor="primary.400"
          top={4}
          left={4}
          aria-label="Open navigation menu"
          icon={<HamburgerIcon />}
          onClick={onOpen}
        />
        <LogoHeader />
      </Flex>
      <Drawer
        placement="left"
        isOpen={isOpen}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent backgroundColor="primary.400">
          <DrawerCloseButton />
          <DrawerHeader>
            <LogoHeader />
          </DrawerHeader>
          <DrawerBody>
            <OrganizationsSelect />
            <StatsMenu />
          </DrawerBody>
          <DrawerFooter>
            <AccountOptions />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};
